import React, { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { Lock, ShieldAlert } from "lucide-react";
import { toast } from "sonner";
import { api } from "../lib/api";
import Logo from "../components/Logo";

const TOKEN_KEY = "mw_admin_token";

export const getAdminToken = () => localStorage.getItem(TOKEN_KEY);
export const setAdminToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearAdminToken = () => localStorage.removeItem(TOKEN_KEY);

const AdminLogin = () => {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    if (getAdminToken()) return <Navigate to="/admin" replace />;

    const submit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            const res = await api.post("/admin/login", { email, password });
            setAdminToken(res.data.token);
            toast.success("Welcome back, Commander.");
            navigate("/admin");
        } catch (err) {
            toast.error("Invalid credentials.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="bg-black min-h-screen flex items-center justify-center px-6 py-20" data-testid="admin-login-page">
            <div className="w-full max-w-md">
                <div className="text-center mb-10">
                    <Logo size={56} />
                    <div className="mt-4 font-display text-3xl tracking-[0.18em]">MINDWORKS</div>
                    <div className="mt-1 text-[10px] tracking-[0.3em] text-red-600">COMMAND CONSOLE</div>
                </div>

                <form onSubmit={submit} className="border border-white/15 bg-[#0a0a0a] p-8 space-y-5" data-testid="admin-login-form">
                    <div>
                        <div className="font-stencil text-xs tracking-widest text-red-600 mb-1">EMAIL</div>
                        <input
                            type="email"
                            required
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            className="w-full px-4 py-3 bg-black border border-white/15 focus:border-red-600 outline-none text-white"
                            data-testid="admin-email"
                        />
                    </div>
                    <div>
                        <div className="font-stencil text-xs tracking-widest text-red-600 mb-1">PASSWORD</div>
                        <input
                            type="password"
                            required
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            className="w-full px-4 py-3 bg-black border border-white/15 focus:border-red-600 outline-none text-white"
                            data-testid="admin-password"
                        />
                    </div>
                    <button
                        type="submit"
                        disabled={loading}
                        className="w-full btn-primary justify-center disabled:opacity-50"
                        data-testid="admin-login-submit"
                    >
                        <Lock size={16} />
                        {loading ? "Authenticating..." : "Enter Console"}
                    </button>
                </form>

                <div className="mt-6 flex items-start gap-2 text-xs text-white/40">
                    <ShieldAlert size={12} className="flex-shrink-0 mt-0.5" />
                    Restricted area. Credentials are set in backend `.env`.
                </div>
            </div>
        </div>
    );
};

export default AdminLogin;
